import { GreenGiffColored } from '@teko/ds-icon';
import { Image, Shape, TabItem, Tabs, Title, styled } from '@teko/ds-mobile';
import { useTenantConfig } from 'hooks';
import { t } from 'i18n';

type PaymentPromotionItems = {
  logoUrl: string;
  altLogo?: string;
  content: string;
  expirationDate?: string;
};

export const PaymentPromotion = () => {
  const LOGO_DIMENSION = 48;

  const { paymentPromotions = [] as PaymentPromotionItems[], isMobile } =
    useTenantConfig();

  if (!paymentPromotions?.length) return null;

  return (
    <StyledShape margin={['s16', 's0']} marginTop={isMobile ? 's16' : 's8'}>
      <StyledHeaderContent>
        <GreenGiffColored size={20} />
        <StyledTitle> {t('Ưu đãi thanh toán')}</StyledTitle>
      </StyledHeaderContent>
      <StyledTabs>
        {paymentPromotions.map((item) => {
          return (
            <TabItem
              key={item.logoUrl}
              icon={
                <Image
                  src={item.logoUrl}
                  alt={item.altLogo || item.logoUrl}
                  width={LOGO_DIMENSION}
                />
              }
            >
              <StyledContent
                dangerouslySetInnerHTML={{ __html: item.content || '' }}
              />
              {item.expirationDate && (
                <StyledExpirationDate>
                  {t('HSD:')} {item.expirationDate}
                </StyledExpirationDate>
              )}
            </TabItem>
          );
        })}
      </StyledTabs>
    </StyledShape>
  );
};

const StyledShape = styled(Shape)`
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background-color: #fff;
`;

const StyledHeaderContent = styled.div`
  padding: 8px;
  background-color: #f5f5f5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
`;

const StyledTitle = styled(Title)`
  margin-left: 4px;
  font-size: 15px;
  font-weight: 500;
`;

const StyledTabs = styled(Tabs)`
  padding: 8px;
  padding-top: 0;

  > div[type='line'] {
    margin-bottom: 8px;
    gap: 16px;

    > div[type='line'] {
      padding: 0;
    }

    &::after {
      width: 48px;
    }
  }
`;

const StyledContent = styled.div`
  ul {
    padding-left: 2rem;
  }

  a {
    text-decoration: none;
  }

  font-size: 13px;
  line-height: 20px;
  margin-bottom: 8px;
`;

const StyledExpirationDate = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 12px;
  line-height: 16px;
`;
